import { render, staticRenderFns } from "./AssetItemProperty.vue?vue&type=template&id=569d7b63&scoped=true&"
import script from "./AssetItemProperty.vue?vue&type=script&lang=js&"
export * from "./AssetItemProperty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "569d7b63",
  null
  
)

export default component.exports